
import { NewCoursePopOption } from '@xt/client/types/home'
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import LazyImg from '@xt/www/components/lazyImg/index.vue'

@Component({
  components: {
    LazyImg
  }
})
export default class NewCoursePop extends Vue {
  option: NewCoursePopOption | null = null

  visible: boolean = false

  hide() {
    this.visible = false
  }

  open(option: NewCoursePopOption) {
    this.option = option
    this.visible = true
  }

  @Emit('closed')
  onClosed() {}

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
